import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import HPESVG from '../../../assets/icons/clouds/hpe.svg?raw';

export const HPELogo = (props) => <CustomSVG svg={HPESVG} preserveColors {...props} />;
